import React from 'react';
import PropTypes from 'prop-types';

const ProfileInvoicesList = ({ forwardedRef, children }) => {
  const refList = forwardedRef || null;

  return <div ref={refList}>{children}</div>;
};

ProfileInvoicesList.propTypes = {
  children: PropTypes.node,
  forwardedRef: PropTypes.object
};

export default ProfileInvoicesList;
